import { render, staticRenderFns } from "./drip-campaign-header.vue?vue&type=template&id=80c6e38c"
import script from "./drip-campaign-header.vue?vue&type=script&lang=js"
export * from "./drip-campaign-header.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports